import { bool } from "prop-types";

import styled from "styled-components";

import logoBrand from "Login/logo-brand.png";
import logoWhite from "Login/logo-white.png";
import logo from "Login/logo.png";

const urlValue = ({ $isDark, $isLegacy }) => {
  if ($isDark) return logoWhite;
  if ($isLegacy) return logo;
  return logoBrand;
};

const Contents = styled.div`
  display: block;
  background-image: url(${urlValue});
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  width: 238px;
  height: 52px;
`;

const FnrBannerLogo = ({ isDark, isLegacy }) => (
  <Contents $isDark={isDark} $isLegacy={isLegacy} />
);

FnrBannerLogo.propTypes = {
  isDark: bool,
  isLegacy: bool,
};

export default FnrBannerLogo;
